import { Tag, Flex, FloraButton } from '@grupoboticario/flora-react';
import { Image2Icon } from '@grupoboticario/flora-react-icons';
import { Link } from 'react-router-dom';

import { ResponsiveFloraTypography } from 'components';
import config from 'config';
import { isMobile as isMobileHelper } from 'helpers';

import Styles from './CustomBanner.styles';

export const CustomBanner = () => {
  const isMobile = isMobileHelper();

  return (
    <Styles.CustomBannerWrapper justify='space-between' align='center'>
      <Styles.CustomBannerTextWrapper direction='column' align='flex-start'>
        <Flex align='center' gap='$2'>
          <ResponsiveFloraTypography fontSize='subtitle' as='h2'>
            Imagens personalizadas
          </ResponsiveFloraTypography>

          <Tag variant='assorted9' aria-label='novo recurso'>
            NOVO
          </Tag>
        </Flex>

        <ResponsiveFloraTypography fontSize='bodyLargeShort' fontWeight='medium'>
          Crie suas próprias imagens personalizadas e envie para clientes ou compartilhe nas redes
          sociais!
        </ResponsiveFloraTypography>
      </Styles.CustomBannerTextWrapper>

      <FloraButton
        as={Link}
        to={`https://vdcards.boticario.com.br/?utm_source=portal_${config.app.short}&utm_medium=materiais`}
        icon={<Image2Icon />}
        has='iconLeft'
        target='_blank'
        rel='noopener noreferrer'
        isFull={isMobile}
        aria-label='criar imagens personalizadas'
        role='button'
        autotagging-flora='on'
        data-flora='button'
        data-flora-text='criar-imagens'
        data-autotagging-flora-section='img_divulgacao'
      >
        <ResponsiveFloraTypography fontSize='bodySmallShort' fontWeight='medium'>
          Criar imagens
        </ResponsiveFloraTypography>
      </FloraButton>
    </Styles.CustomBannerWrapper>
  );
};
